import { render } from "./StoreDetail.vue?vue&type=template&id=62f72796&scoped=true"
import script from "./StoreDetail.vue?vue&type=script&lang=js"
export * from "./StoreDetail.vue?vue&type=script&lang=js"

import "./StoreDetail.vue?vue&type=style&index=0&id=62f72796&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f72796"]])

export default __exports__